<div class="recipientPicker">
  <mat-form-field appearance="outline" class="recipientField">
    <mat-label>{{ 'RECIPIENTS.ROLES' | translate }}</mat-label>
    <mat-select multiple [disabled]="disabled || loading" [value]="selectedRoleIds"
      (selectionChange)="onRolesChange($event.value)">
      <mat-option *ngFor="let role of roles" [value]="role.Id">{{ role.Name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <p class="paragraphText secondaryTextColor recipientHint">{{ 'RECIPIENTS.ROLES_HINT' | translate }}</p>

  <mat-form-field appearance="outline" class="recipientField">
    <mat-label>{{ 'RECIPIENTS.USERS' | translate }}</mat-label>
    <mat-select multiple [disabled]="disabled || loading" [value]="selectedUserIds"
      (selectionChange)="onUsersChange($event.value)">
      <mat-option *ngFor="let user of users" [value]="user.Id">{{ userLabel(user) }}</mat-option>
    </mat-select>
  </mat-form-field>

  <p *ngIf="!loading && isEmpty" class="paragraphText secondaryTextColor recipientEmpty">
    {{ emptyText | translate }}
  </p>
</div>
